import React, { useRef, useState } from "react";
import "./ScrollCasino.css";
import Helper from "../../helper";
import axios from 'axios';
import Appconfig from '../../config/config'
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import Login from "../Login/Login";


const ScrollCasino = () => {
  const [showLoginModel, setShowLoginModel] = useState(false);
  const userInfo = Helper(); // get login user details
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  function CreateAndLaunchWCOCasino(provider_code, game_code, type = null) {
    const userData = {
      user_id: userInfo?._id,
      user_name: userInfo?.user_name,
      redirect_url: 'https://daddyexch.live/',
      provider_code: provider_code,
      game_code: game_code,
      type: type,
    };

    var config = {
      method: "post",
      url: `${Appconfig.casinoUrl}wco/login`,
      headers: {
        "Content-Type": "application/json",
      },

      data: JSON.stringify(userData),
    };

    axios(config)
      .then(function (response) {
        let status = response.data.status?.code;
        if (status === "SUCCESS") {
          window.open(response.data.launchURL, "_self");
        }

        if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
          toast.error('Game Not Found.', { autoClose: 2000 });
        } else if (status == "AUTHENTICATION_FAILED") {
          toast.error(response.data.status?.message, { autoClose: 2000 });
        }

      })
      .catch(function (error) {
        console.log(error);
      });
  }

  function OpenEzugiLobby(casinoType) {
    navigate('/all-games-lobby', { state: { activeCasino: casinoType } });
  }

  // Scroll handler for nav buttons
  const scrollByAmount = (amount) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: amount, behavior: 'smooth' });
    }
  };

  // Touch drag support (optional, for better mobile UX)
  let isDown = false, startX, scrollLeft;
  const handleTouchStart = (e) => {
    isDown = true;
    startX = e.touches[0].pageX - scrollRef.current.offsetLeft;
    scrollLeft = scrollRef.current.scrollLeft;
  };
  const handleTouchMove = (e) => {
    if (!isDown) return;
    const x = e.touches[0].pageX - scrollRef.current.offsetLeft;
    const walk = (startX - x);
    scrollRef.current.scrollLeft = scrollLeft + walk;
  };
  const handleTouchEnd = () => { isDown = false; };

  // All your game buttons as an array for easier mapping
  const games = [
    { provider: '', code: '', type: '', img: 'ezugi.svg', alt: 'Teenpatti Test',  },
    { provider: '', code: '', img: 'Supernova.png', alt: 'Worli Matka' },
    { provider: '', code: '', img: 'ONLYPLAY.png', alt: 'Roulette' },
    { provider: '', code: '', type: '', img: 'bollytech.png', alt: 'Sicbo' },
    { provider: '', code: '', img: 'spribe.svg', alt: 'Poker' },
    { provider: 'SPB', code: 'aviator', img: 'aviatorX.svg', alt: 'Super Over' },
    { provider: 'EVZ', code: '1100517',type: 'EV', img: 'bang-bang-games.svg', alt: '3 Cards Judgement' },
    { provider: '', code: '', type: '', img: 'evolution.svg', alt: 'Teenpatti T20' },
    { provider: 'QT', code: 'HAB-dragoncastle', img: 'habanero.svg', alt: 'Teenpatti Open' },
    { provider: '', code: '', img: 'jilli.svg', alt: 'Dragon Tiger' },
    { provider: '', code: '', img: 'royal-gaming.png', alt: 'Muflis Teenpatti' },
    { provider: 'QT', code: 'KAG-bearrun', img: 'hungry-bear.svg', alt: 'Amar Akbar Anthony' },
    { provider: 'QT', code: 'PSG-animafia', img: 'peter-&-sons.svg', alt: 'Casino War' },
    { provider: '', code: '', img: 'smart-soft.svg', alt: 'Andar Bahar' },
    // { provider: '', code: '', img: 'betsolutions.svg', alt: 'Live Teenpatti' },
    // { provider: '', code: '', img: 'gamzix.svg', alt: '2 Cards Teenpatti' },
    // { provider: '', code: '', img: 'harimastic.svg', alt: '32 Cards Casino' },
    // { provider: '', code: '', img: 'hot-rise-games.svg', alt: 'Bollywood Casino' },
    // { provider: '', code: '', img: 'kingmidas.svg', alt: 'Queen' },
    // { provider: '', code: '', img: 'netentt.svg', alt: 'Baccarat' },
    // { provider: '', code: '', img: 'nothernlights.svg', alt: '29 Card Baccarat' },
    // { provider: 'QT', code: 'PNG-journeytoparis', img: 'play-and-go.svg', alt: 'Casino Meter' },
    // { provider: '', code: '', img: 'playtech.svg', alt: 'Trio' },
    // { provider: 'QT', code: 'QS-brooklynbootleggers', img: 'quickspin.svg', alt: 'Hi Low' },
    // { provider: '', code: '', img: 'red-tiger.svg', alt: 'Race 20 20' },
    // { provider: '', code: '', img: 'reeplay.svg', alt: 'Race to 17' },
    // { provider: '', code: '', img: 'reflex-gaming.svg', alt: '7 Up Down' },
    // { provider: '', code: '', img: 'the-players.svg', alt: 'Poker 20 20' },
    // { provider: 'QT', code: 'YGG-vikingsgotoegyptwildfight', type: 'EV', img: 'yggdrasil.svg', alt: 'Six Player Poker' },
    // { provider: 'AC', code: '985672', type: 'EV', img: 'dream_catcher.webp', alt: 'Dream Catcher' },
  ];

  // Split games into columns of 3 (for 3 rows)
  const columns = [];
  for (let i = 0; i < games.length; i += 3) {
    columns.push(games.slice(i, i + 3));
  }

  

  return (
    <>
    {/* Popular Games Start */}
      <div className="live-casino rounded-[10px] mt-2.5" style={{ background: '#ffffff'}}>
        <div title="Game Providers" className="px-[6px] w-full">
          <div className="bg-bg_color_primary rounded-[10px] flex flex-col divide-y divide-divide_color_primary">
            <div className="w-full flex flex-row justify-between px-3 py-1.5">
              <div className="max-w-[85%] text-text_color_primary1 font-semibold capitalize cursor-pointer">
                <div className="flex items-center gap-1.5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="var(--icon-color-brand-secondary)"
                    viewBox="0 0 16 16"
                    height="20"
                    width="20"
                  >
                    <path
                      d="M8 16c3.314 0 6 -2 6 -5.5 0 -1.5 -0.5 -4 -2.5 -6 0.25 1.5 -1.25 2 -1.25 2C11 4 9 0.5 6 0c0.357 2 0.5 4 -2 6 -1.25 1 -2 2.729 -2 4.5C2 14 4.686 16 8 16m0 -1c-1.657 0 -3 -1 -3 -2.75 0 -0.75 0.25 -2 1.25 -3C6.125 10 7 10.5 7 10.5c-0.375 -1.25 0.5 -3.25 2 -3.5 -0.179 1 -0.25 2 1 3 0.625 0.5 1 1.364 1 2.25C11 14 9.657 15 8 15"
                      strokeWidth="1"
                    ></path>
                  </svg>
                  <span className="text-base text-text_color_primary1 font-normal">
                    Game Providers
                  </span>
                </div>
              </div>
              <div className="flex w-[108.75px] items-center justify-end gap-[5px]">
                <button
                  className="inline-block leading-normal relative overflow-hidden transition duration-150 ease-in-out font-lato bg-bg_text_brand_secondary text-transparent bg-clip-text font-semibold text-[12px] leading-[18px] cursor-pointer"
                  type="button"
                >
                  See All
                </button>
                <button
                  className="inline-block leading-normal relative overflow-hidden transition duration-150 ease-in-out flex w-[22px] h-[22px] justify-center items-center bg-bg_color_quaternary rounded border cursor-pointer"
                  type="button"
                  onClick={() => scrollByAmount(-220)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="var(--icon-color-brand-secondary)"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M15 6l-6 6l6 6"></path>
                  </svg>
                </button>
                <button
                  className="inline-block leading-normal relative overflow-hidden transition duration-150 ease-in-out flex w-[22px] h-[22px] justify-center items-center bg-bg_color_quaternary rounded border cursor-pointer"
                  type="button"
                  onClick={() => scrollByAmount(220)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="var(--icon-color-brand-secondary)"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M9 6l6 6l-6 6"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
            className="scrollable-box three-row-scroll"
            ref={scrollRef}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
          <div className="scroll-casino-grid">
            {columns.map((col, colIdx) => (
              <div key={colIdx} className="flex flex-col gap-2">
                {col.map((game, rowIdx) => {
                  const imgToProvider = {
                    'ezugi.svg': 'ezugi',
                    'Supernova.png': 'sn',
                    'spribe.svg': 'spribe',
                    'ONLYPLAY.png': 'onlyplay-casino',
                    'evolution.svg': 'evolution',
                    'royal-gaming.png': 'royal-gaming',
                    'jilli.svg': 'jilli-casino',
                    'smart-soft.svg': 'smartsoft-casino',
                    // add more mappings as needed
                  };
                  const providerKey = imgToProvider[game.img];

                  return (
                    <div
                      key={game.code + rowIdx}
                      onClick={() => {
                        if (!userInfo || !userInfo._id) {
                          setShowLoginModel(true);
                        } else if (providerKey) {
                          OpenEzugiLobby(providerKey);
                        } else {
                          CreateAndLaunchWCOCasino(game.provider, game.code, game.type);
                        }
                      }}
                      className="relative overflow-hidden min-w-[124px] md:min-w-[150px] aspect-[2.27] rounded-md inline-block active:scale-95 transition-all duration-100 ease-in-out bg-bg_color_casinoProvider shadow-md cursor-pointer"
                      title={game.alt}
                    >
                      <img
                        src={`../Images/Game-Provider/${game.img}`}
                        alt={game.alt}
                        className="w-full max-h-[94%] [@supports(-webkit-touch-callout:none)]:h-full"
                        loading="lazy"
                      />
                    </div>
                  );
                })}
              </div>
            ))}
          </div>


        </div>

      </div>
      <Login
        showPopup={showLoginModel}
        togglePopup={() => setShowLoginModel(false)}
        // Pass other required props here
      />
    {/* Popular Games End */}

    {/* Casino Provider Start */}
      {/* <div className="casino-background">
        <div className="live-casino" style={{ background: '#ffffff'}}>
          <div className="header-container" style={{ padding: '10px 0' }}>
            <div className="title" style={{ color: "#000" }}>Casino Provider</div>
          </div>
          <div className="scrollable-box">
            <div className="casino-provider-layout">
              <div className="grid-cols-div">
                <div
                  onClick={() => OpenEzugiLobby('evolution')}
                  className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/evolution.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('ezugi')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/ezugi.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('jilli-casino')}  className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/jili.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div
                  onClick={() => OpenEzugiLobby('ezugi')} 
                  className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/gamzix.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('kingmaker-casino')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/kingmaker.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('smartsoft-casino')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/smartsoft.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('mac888')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/mac88virtualgame.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => CreateAndLaunchWCOCasino(`BGS`, ``, '')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/playtech.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('mac888')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/mac88.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('mac888')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/vsport.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('evolution')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/evoplay.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('ezugi')}  className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/fungames_500-299.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => CreateAndLaunchWCOCasino()} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/bombaylive.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('bet-games')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/betgames.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('ezugi')}  className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/aesexy.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('spribe')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/spribe.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => OpenEzugiLobby('ezugi')} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/turbogames.webp" alt="" style={{ width: '100%' }} />
                </div>
                <div onClick={() => CreateAndLaunchWCOCasino()} className="image-setting-live-casino col-4-div">
                  <img src="../Images/Casino_providers/vivogaming.webp" alt="" style={{ width: '100%' }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    {/* Casino Provider End */}
    </>
  );
};

export default ScrollCasino;
